export enum ByteCollectionItemType {
  Byte = 'Byte',
  ClickableDemo = 'ClickableDemo',
  ShortVideo = 'ShortVideo',
}
